<template>
  <div style="background-color: #efeeee !important" class="pageContainer">
  <v-container style="max-width: 900px !important">
    <ShipmentDetails />
  </v-container>
  </div>
</template>

<script>
import ShipmentDetails from "@/components/shipmentDetails.vue"

export default {
  components: {
    ShipmentDetails,
  },
  data (){
    return{

    }
  }
}
</script>

<style scoped>
.pageContainer {
  display: flex;
  justify-content: center;
}
</style>
